var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card card-fancy",class:_vm.classes},[(_vm.hasHeaderSlot)?_c('div',{staticClass:"card-header"},[_vm._t("header"),_vm._v(" "),_vm._t("header-actions")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card-content"},[_vm._t("default")],2),_vm._v(" "),(_vm.hasFooterSlot)?_c('div',{staticClass:"card-footer"},[_vm._t("footer")],2):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67658640","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/AppCard.vue
// module id = U8Yl
// module chunks = 0